import { computed, effect, inject, Injectable, untracked } from '@angular/core';
import { Router } from '@angular/router';
import { GrunddatenService } from './grunddaten.service';
import { FreigabeSchluessel, regelFuer } from './freigabe-regeln';

@Injectable({ providedIn: 'root' })
export class FreigabeService {
  private grunddaten = inject(GrunddatenService);
  private router = inject(Router);

  private station = computed(() => {
    const id = this.grunddaten.idStation();
    return id > 0 ? this.grunddaten.reguliererDB().find((r) => Number(r.idStation) === id) : undefined;
  });

  readonly freigaben = computed<Partial<Record<FreigabeSchluessel, boolean>>>(() => {
    const s = this.station();
    if (!s) return {};
    return {
      webshop: s.neuerShop,
    };
  });

  constructor() {
    effect(() => {
      this.freigaben();
      untracked(() => {
        if (!this.erlaubt(this.router.url)) this.router.navigate(['/']);
      });
    });
  }

  erlaubt(url: string): boolean {
    const regel = regelFuer(url);
    if (!regel) return true;
    return this.freigaben()[regel.schluessel] !== false;
  }
}
